import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";
import { WorkerVehicle } from "./worker-vehicle";
import { Business } from "../../business/_types/business";
import { Worker } from "./worker";
import { Tax } from "../../taxes/_types/tax";
import { WorkerBillableItemType } from "./worker-billable-item-type";
import { Zone } from "../../zones/_types/zone";
import { TypeContract } from "../../common/_types/type-contract";
import { ColectiveAgreement } from "../../common/_types/colective-agreement";

export class WorkerContract extends Resource {
    public override type = 'workerContracts';

    @prop()
    @required()
    public workerId!: string;
    public worker!: Worker;

    @prop()
    @required()
    public typeContractId!: string;
    public typeContract!: TypeContract;

    @prop()    
    public colectiveAgreementId?: string;
    public colectiveAgreement?: ColectiveAgreement;

    @prop()
    @required()
    public hours!: number;    
    @prop()    
    public salary?: number;
    @prop()
    public hourlyCost?: number;

    @prop()
    public startDate!: Date;

    @prop()
    public endDate!: Date;



    @prop()
    @required()
    public active: boolean = false;

}